export enum TriggerTypeEnum {
    MANUAL = 1,
    PAGE_LOAD = 2,
}